import { ACTION_TYPES } from './actionTypes';

export function changeStep(values) {
  return {
    type: ACTION_TYPES.CHANGE_STEP,
    payload: values,
  };
}

export function setLoading(isLoading) {
  return {
    type: ACTION_TYPES.LOADING,
    payload: {
      isLoading,
    },
  };
}

export function setOrganization(organization) {
  return {
    type: ACTION_TYPES.SET_ORGANIZATION,
    payload: {
      organization,
    },
  };
}

export function initializeFromStorage() {
  return {
    type: ACTION_TYPES.INITIALIZE_FROM_STORAGE,
  };
}

export function setPaymentProfile(profile) {
  const { vindi_customer_id, vindi_payment_profile_id } = profile || {};
  return {
    type: ACTION_TYPES.SET_PAYMENT_PROFILE,
    payload: profile ? { vindi_customer_id, vindi_payment_profile_id } : null,
  };
}

export function clearSubscription() {
  return {
    type: ACTION_TYPES.CLEAR_SUBSCRIPTION,
  };
}

const api = {
  post() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true);
      }, 2000);
    });
  },
};

export const fetchAddressByZipcode = (data) => async (dispatch) => {
  dispatch(setLoading(true));

  try {
    await api.post(data);
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(setLoading(false));
  }
};
